import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { Analysis, Partner } from 'www/vue_components/common/Analyses/types'

/**
 * Store для управления и хранения данных о конкретном партнере и его анализах
 * для страницы списка анализов конкретного партнера, например kdl
 */

const usePartnerAnalysesStore = defineStore('analysesStore', () => {
  const partner = reactive<Partial<Partner>>({
    id: undefined,
    name: undefined,
    discount: undefined,
    analyses: [],
  })

  function isPartner(partner: Partner | Partial<Partner>): partner is Partner {
    return (partner as Partner).id !== undefined
  }

  function setPartner(newPartner: Partner) {
    Object.assign(partner, newPartner)
  }

  function updatePartnerAnalyses(newAnalysesList: Analysis[]) {
    const analysesLength = partner.analyses!.length

    partner.analyses!.splice(0, analysesLength, ...newAnalysesList)
  }

  function updateAnalysisIsInCartProperty(analysisId: number, biomaterialId: number, isInCart: boolean) {
    if (!partner.analyses?.length) {
      return
    }

    const analysis = partner.analyses.find(
      analysis => (analysis.id === analysisId && analysis.biomaterial_id === biomaterialId),
    )

    analysis!.is_in_cart = isInCart
  }

  return {
    partner,
    updateAnalysisIsInCartProperty,
    updatePartnerAnalyses,
    setPartner,
    isPartner,
  }
})

export default usePartnerAnalysesStore
